import { Routes } from '@angular/router';
import { AuthContextEnum } from '@feature-auth';
import { LandingLayout, LandingRouteData } from '@feature-landing';
import { CustomersPage } from './main/customers/customers-page';
import { DriversPage } from './main/drivers/drivers-page';
import { MainPage } from './main/main-page';
import { PrivacyPolicyPage } from './privacy-policy-page/privacy-policy-page';

// The landing pages ship in the main bundle: visitors browse all of them, and a page that is not a
// separate chunk cannot go missing when a deploy replaces the chunks under an open tab.
export const routes: Routes = [
  {
    path: '',
    component: LandingLayout,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: MainPage,
        data: { createAccountContext: AuthContextEnum.CreateAccount } satisfies LandingRouteData,
      },
      {
        path: 'drivers',
        pathMatch: 'full',
        component: DriversPage,
        data: {
          createAccountContext: AuthContextEnum.CreateCarrierAccount,
        } satisfies LandingRouteData,
      },
      {
        path: 'shippers',
        pathMatch: 'full',
        component: CustomersPage,
        data: {
          createAccountContext: AuthContextEnum.CreateCustomerAccount,
        } satisfies LandingRouteData,
      },
    ],
  },
  {
    path: 'choose-account',
    loadComponent: () =>
      import('./choose-account-page/choose-account-page').then((c) => c.ChooseAccountPage),
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyPage,
  },
  {
    path: 'delete-account',
    loadComponent: () =>
      import('./delete-account-page/delete-account-page').then((c) => c.DeleteAccountPage),
  },
  {
    path: 'tracking',
    loadChildren: () => import('./tracking/tracking.routes').then((c) => c.trackingRoutes),
  },
  {
    path: 'magic-link',
    loadChildren: () => import('@feature-magic-links').then((m) => m.magicLinksRoutes),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
